'use strict';

/**
 * Top Load
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	function startVideo () {
		let $this = $(this);
		let $video = $(this).find('video');
		let video = $video.get(0);

		if (typeof $video.attr('src') === 'undefined') {
			$video.attr('src', $video.data('src'));
		}

		video.play();
		video.controls = true;
		$this.removeClass('is-video-hide').addClass('is-play');

		video.addEventListener('ended', function () {
			resetVideo($this, video);
		});
	}

	function resetVideo ($el, video) {
		$el.removeClass('is-play');
		video.controls = false;
	}

	$('.js-play-video').on('click', function () {
		startVideo.call(this);
	});

	$('body').on('click', '.js-play-nvideo', function () {
		let $video = $(this).find('video');
		let video = $video.get(0);
		video.play();
		video.controls = true;
		$(this).addClass('is-play');

		$video.on('click', function (e) {
			e.stopPropagation();
		});
	});

	$('.js-video').on('click', function (e) {
		e.stopPropagation();
		if (this.paused) {
			this.play();
		} else {
			this.pause();
		}
	});

	$('.js-hover-video').on('mouseenter', '.js-case-video', function () {
		let _this = this;
		let $this = $(_this);

		if (typeof $this.attr('src') === 'undefined') {
			$this.attr('src', $this.data('src'));
		}

		this.playbackRate = 0.7;
		this.play();
	}).on('mouseleave', '.js-case-video', function () {
		this.pause();
	});
})(window.jQuery);



// WEBPACK FOOTER //
// ./src/js/_modules/video.js